<template>
    <div class="form-sub-section notes-section">
        <div class="d-flex justify-content-between align-items-center mr-auto">
            <h3 class="main-text-large">{{ $t("res_DialogTitle_DispatchInfo_Online") }}</h3>
            <v-btn @click="collapseDispatchInfo = !collapseDispatchInfo"
                class="dgs-new-button" style="width: 40px; min-width: unset !important">
                <span v-if="collapseDispatchInfo" class="arrow-down"></span>
                <span v-else class="arrow-up"></span>
            </v-btn> 
        </div>
        <v-divider v-if="!collapseDispatchInfo && dispatchInfoList.length > 0"></v-divider>
        <div class="with-view-all" :style="{ display: collapseDispatchInfo ? 'none':'block' }">
            <v-list>
                <v-list-item class="text-hover-list" v-for="(item, i) in dispatchInfoList" :key="i">
                    <v-list-item-content>
                        <v-list-item-title>
                            <div class="text-wrap w-75">
                                <span>
                                    <strong>{{ $t("res_GridHeaders_ToStructure") }}: </strong>&nbsp;{{ item.recieverStructure }}
                                </span>
                            </div>
                            <div class="text-wrap w-75">
                                <span>
                                    <strong>{{ $t("res_Label_ForwardDate") }}: </strong>&nbsp;{{ utils.dateFormat(item.sendDate, 'dd/MM/yy', true) }}</span>
                            </div>
                            <div class="text-wrap w-75">
                                <span>
                                    <strong>{{ $t("res_Label_DispatchReceivedBy") }}:</strong>&nbsp;{{ item.recieverUser }}
                                </span>
                            </div>
                            <div class="text-wrap w-75">
                                <span>
                                    <strong>{{ $t("res_Label_DispatchReceivedDate") }}: </strong>&nbsp;{{ utils.dateFormat(item.openDate, 'dd/MM/yy', true) }}
                                </span>
                            </div>
                            <div class="text-wrap w-75">
                                <span>
                                    <strong>{{ $t("res_Label_DispatchReferenceNumber") }}: </strong>&nbsp;{{ item.referenceNumber }}
                                </span>
                            </div>
                            <div class="text-wrap w-75">
                                <span>
                                    <strong>{{ $t("res_Label_DispatchStatus") }}: </strong>&nbsp;{{ $t("res_Label_DispatchStatusResult") }}
                                </span>
                            </div>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import constants from '@/assets/js/constants'
    import * as utils from '@/assets/js/common.js'

    export default {
        name: 'DispatchInfo',
        props: {
            documentId: { type: [String, Number], default: '0' }
        },
        data: () => (
            {
                dispatchInfoList: [],
                utils: utils,
                collapseDispatchInfo: true
            }
        ),
        watch:
        {
            documentId(newVal, oldVal) 
            {
                if (oldVal != newVal && newVal > 0)
                    this.getDispatchInfo()
            }
        },
        methods:
        {
            getDispatchInfo() 
            {
                if (this.documentId == 0) return
                this.dispatchInfoList = []

                axios.get(constants.baseApiUrl + 'Dispatch/GetDispatchInfo?documentId=' + this.documentId)
                    .then(res => this.dispatchInfoList = res.data)
                    .catch(error => this.handleError(error))
            }
        },
        mounted() 
        {
            this.getDispatchInfo()
        }
    }
</script>